import React, { useState, useContext } from "react";

import { useHistory } from "react-router-dom";
import { ALL_LOCATIONS_QUERY } from "../../../graphql/Locations/Locations.graphql";

import { AddLocationForm } from "../../../components/Locations";
import { ModalContext } from "../../../components/ModalProvider";
import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import LocationFilters from "./LocationFilters";

import { getFilterState, saveFilterState } from "../../../utils";

const LocationsPage = () => {
  const history = useHistory();

  const INITIAL_FILTER_STATE = getFilterState("LOCATION_FILTERS", {
    Active: true
  });

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);

  const handleSetFilters = inputs => {
    saveFilterState("LOCATION_FILTERS", inputs);
    setFilters({ ...inputs });
  };

  const resetFilters = () => handleSetFilters({ Active: true });

  const { setModalOpen } = useContext(ModalContext);
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={LocationFilters}
        columns={COLUMNS}
        filters={filters}
        name="Locations"
        query={ALL_LOCATIONS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Locations"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddLocationForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_LOCATIONS_QUERY}
        initialSortBy={[{ id: "LocationId", desc: false }]}
        name="Location"
        where={filters}
        onRowClick={data =>
          history.push(`/dispatch/locations/${data.RecId}/details`)
        }
      />
    </React.Fragment>
  );
};

LocationsPage.propTypes = {};

export default LocationsPage;
